
























































import { Prop, Component, Mixins } from "vue-property-decorator";
import InputMixin from "../private/InputMixin";

@Component({
    directives: {
        focus: {
            inserted: function (el, binding) {
                if (binding.value) {
                    el.focus();
                }
            },
        },
    },
})
export default class AbcFileInput extends Mixins(InputMixin) {
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isFocused!: boolean;
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: null }) info!: string | null;
    @Prop({ default: null }) placeholder!: string | null;
    @Prop({ type: Boolean }) buttons!: boolean;
    @Prop({ type: Boolean }) textRight!: boolean;
    @Prop({ default: null }) accept!: string | null; //file type - https://www.iana.org/assignments/media-types/media-types.xhtml

    private haveFocus = false;
    private haveHover = false;
    private filename: string | null = null;

    private get currentVal(): unknown {
        return this.value;
    }

    private set currentVal(val: unknown) {
        this.runRules(val);
        this.$emit("input", val);
    }

    private updateCurrentVal(e: any) {
        if (e && e.target && e.target.files && e.target.files.length > 0) {
            this.currentVal = e.target.value;
            const fileData = e.target.files[0];
            this.filename = fileData.name;
            this.$emit("file-change", e.target.files);
        } else {
            this.filename = null;
            this.currentVal = null;
        }
    }

    private focusChanged(on: boolean) {
        this.haveFocus = on;
        if (!on) {
            this.runRules(this.value);
            this.$emit("blur");
        } else {
            this.$emit("focus");
        }
    }


    //style
    private get wrapperClass(): { [key: string]: boolean } {
        return {
            "border-border dark:border-border-dark": !this.haveHover && !this.haveFocus && !this.haveErrors,
            "border-secondary-300":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !this.haveErrors,

            "border-danger-400 dark:border-danger-dark-400": !!this.haveErrors,
            "border-danger-500 dark:border-danger-dark-500":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !!this.haveErrors,

            "abc-file-input-focused": this.haveFocus && !this.haveErrors,
            "abc-file-input-focused-error": this.haveFocus && !!this.haveErrors,

            "cursor-pointer": !this.isDisabled,

            "bg-bg-100 dark:bg-bg-dark-100": !this.isDisabled,
            "bg-bg-500 dark:bg-bg-dark-500 text-label-primary dark:text-label-primary-dark": this.isDisabled,
        };
    }
}
